import React, { useEffect, useState } from "react";
import BreadCrumbsGeneric from "../../components/Nav/BreadCrumbsGeneric";
import { Link, useLocation } from "react-router-dom";
import {
  CursorClickIcon,
  WifiIcon,
  PhoneIcon,
  DesktopComputerIcon,
} from "@heroicons/react/outline";
import { UseContextApp } from "../../Global/Context/appContext";
import { colors } from "../../propsType/Colors";
const people = [
  {
    name: "Internet",
    icon: WifiIcon,
    href: "/cuenta/pagos",
    numCuenta: "1023655",
    link: "Ver Factura",
  },
  {
    name: "Servicios Televisión",
    icon: DesktopComputerIcon,
    numCuenta: "1023655",
    link: "Ver Factura",
  },
  {
    name: "NetUno GO",
    icon: CursorClickIcon,
    numCuenta: "1023655",
    link: "Ver Factura",
  },
  {
    name: "Servicios de Telefonia",
    icon: PhoneIcon,
    numCuenta: "1023655",
    link: "Ver Factura",
  },
];
function Inquiries() {
  const [{ consumoData }] = UseContextApp();
  const location = useLocation();
  const pathName = location.pathname;

  useEffect(() => {

  }, [consumoData]);

  return (
    <div className=" bg-[#f3f4f6] ">
      <div className="flex max-w-7xl mx-auto  pt-6 justify-center min-h-screen">
        <>
          <div className="flex lg:w-full px-4  gap-5 flex-col">
            <BreadCrumbsGeneric locations={pathName} />
            <div className="p-7  pl-0">
              <div className="py-2 text-2xl font-medium ">Consultas</div>
              <div className=" text-lg font-regular ">
                Texto referencial Texto referencial Texto referencial Texto
                referencial Texto referencial Texto referencial Texto
                referencial Texto referencial{" "}
              </div>
            </div>
            <div className="!m-0 overflow-x-auto sm:-mx-6 p-5 lg:-mx-8 bg-white rounded-[10px] shadow-lg  mt-5 ">
              <div className="space-y-8 lg:py-6 sm:space-y-12">
                <ul
                  role="list"
                  className="mx-auto grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-4 md:gap-x-6   xl:grid-cols-4"
                >
                  {people.map((person) => (
                    <li key={person.name}>
                      <div className="space-y-4 flex flex-col justify-center rounded-xl items-center py-8 px-8 bg-gray-50">
                        <div className={`shadow-style border-[${colors.darkBlue}] border-[2px] w-[120px] h-[120px] bg-white rounded-full flex justify-center items-center `}>
                          <person.icon
                            alt=""
                            className={`flex-shrink-0 h-14 w-14 text-[${colors.lightBlue}]`}
                          />
                        </div>
                        <div className="space-y-2">
                          <div className="text-xs font-medium text-center lg:text-lg">
                            <h3>{person.name}</h3>
                            <p className={`text-[${colors.darkBlue}]`}>{person.numCuenta}</p>
                            <Link className={`text-[${colors.lightBlue}]`}>
                              {person.link}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </>
      </div>
    </div>
  );
}

export default Inquiries;
